<div class="controlsContainer">
  <app-image-slider [s3Uri]="s3Uri" [loading]="loading" [payload]="payload" [sliderIndex]="sliderIndex" [crntDir]="crntDir" [index]="index" (sliderEvent)="sendEvent($event)" ></app-image-slider> <!---->
  <app-map-view [loading]="loading" [view]="view" [payload]="payload" [crntDir]="crntDir" [index]="index" ></app-map-view>
</div>

